'use client';

import { useMutation } from '@tanstack/react-query';

import { ImproveProfessionalBioParams, improveProfessionalBio } from '@website/services/professionals.service';

export function useImproveProfessionalBio() {
  return useMutation({
    mutationFn: (params: ImproveProfessionalBioParams) => improveProfessionalBio(params)
  });
}
